import store from '@/store'

/**
 * @param { { route: string, demandType: number} } params - params
 */
export default async function useStatisticsRouteFetch(demandType = 0, routeName = 'CallInflux') {
  return store.dispatch('chart/fetchStatisticRoute', {
    demandType: demandType || 0,
    route: routeName,
  })
}
